import React, { useMemo } from 'react';
import { StyleSheet } from 'react-native';
import { DNABox } from '@alucio/lux-ui';
import colors from '@alucio/lux-ui/src/theming/themes/alucio/colors';
import ComplianceRuleChecker from './ComplianceRuleChecker';
import { usePresentationBuilderState } from '../PresentationBuilder/state/PresentationBuilderStateProvider';
import { FILE_TYPE } from '@alucio/aws-beacon-amplify/src/API';

const styles = StyleSheet.create({
  mainContainer: {
    borderColor: colors['color-gray-100'],
    borderLeftWidth: 1,
    width: 320,
    backgroundColor: colors['color-text-white'],
  },
  contentContainer: {
    paddingVertical: 16,
  },
});

const CompliancePanel: React.FC = () => {
  const { customDeck, selectedGroups } = usePresentationBuilderState();

  const customDeckId = useMemo(() => {
    return customDeck?.model.id || 'draft-presentation';
  }, [customDeck]);

  const pageIds = useMemo(() => {
    return selectedGroups
      .filter((group) => group.visible)
      .filter((group) => {
        const documentType = group.documentVersionORM?.model.type
        return documentType === FILE_TYPE.PDF || documentType === FILE_TYPE.PPTX;
      })
      .flatMap((group) => group.pages.map((page) => page.pageId));
  }, [selectedGroups]);

  return (
    <DNABox appearance="col" style={styles.mainContainer}>
      <DNABox style={styles.contentContainer} appearance="col" fill>
        <ComplianceRuleChecker
          customDeckId={customDeckId}
          pageIds={pageIds}
        />
      </DNABox>
    </DNABox>
  );
};

export default CompliancePanel;
